import React from 'react';

import Header from '../../layout/Header.jsx';
import ListShares from '../../lists/ListShares.jsx';

const PageShares = () => (
  <div>
    <Header>Shares</Header>
    <ListShares />
  </div>
);

export default PageShares;
